import React from 'react';

import { Leg, Marker, RouteData } from './common';

interface ComponentProps {
  routeData: RouteData;
  markers: Marker[];
}

const RouteInfo: React.FC<ComponentProps> = ({ routeData, markers }) => {
  const { leg_overviews } = routeData;
  return (
    <div>
      <h6 className="fw-bold">Route Information</h6>
      {leg_overviews && (
        <div className="table-responsive">
          <table className="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Leg</th>
                <th>From</th>
                <th>To</th>
                <th>Distance</th>
                <th>Duration</th>
              </tr>
            </thead>
            <tbody>
              {leg_overviews.map((legOverview: Leg, legIndex: number) => {
                const fromMarker =
                  markers.find((marker) => marker.orderId === legIndex) ||
                  (legIndex === 0 ? markers.find((marker) => marker.type === 'origin') : null);
                const toMarker =
                  markers.find((marker) => marker.orderId === legIndex + 1) ||
                  (legIndex === leg_overviews.length - 1 ? markers.find((marker) => marker.type === 'origin') : null);

                return (
                  <tr key={`leg-${legIndex}`}>
                    <td>{legIndex + 1}</td>
                    <td>{fromMarker?.data.name || `Stop ${legIndex}`}</td>
                    <td>{toMarker?.data.name || `Stop ${legIndex + 1}`}</td>
                    <td>{legOverview.distance.toFixed(1)} km</td>
                    <td>{legOverview.duration} min</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RouteInfo;
